import './PayTable.scss';
import { useTranslation } from '../../stores';

export const PayTable = () => {
  const t = useTranslation();
  return (
    <div className="pay-table-component">
      <h3>{t('PAY_TABLE')}</h3>
      <table>
        <thead>
        <tr>
          <th className=""></th>
          <th className="">1</th>
          <th className="">2</th>
          <th className="">3</th>
          <th className="">4</th>
          <th className="">5</th>
          <th className="">6</th>
          <th className="">7</th>
          <th className="">8</th>
          <th className="">9</th>
          <th className="">10</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <th className="">0</th>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className="">1</td>
          <td className="">1</td>
          <td className="">2</td>
          <td className="">3</td>
        </tr>
        <tr>
          <th className="">1</th>
          <td className="">3.5</td>
          <td className="">1</td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
        </tr>
        <tr>
          <th className="">2</th>
          <td className=""></td>
          <td className="">10</td>
          <td className="">2</td>
          <td className="">1.5</td>
          <td className="">1</td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
        </tr>
        <tr>
          <th className="">3</th>
          <td className=""></td>
          <td className=""></td>
          <td className="">50</td>
          <td className="">10</td>
          <td className="">3</td>
          <td className="">2</td>
          <td className="">2</td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
        </tr>
        <tr>
          <th className="">4</th>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className="">80</td>
          <td className="">30</td>
          <td className="">15</td>
          <td className="">5</td>
          <td className="">5</td>
          <td className="">2</td>
          <td className=""></td>
        </tr>
        <tr>
          <th className="">5</th>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className="">150</td>
          <td className="">70</td>
          <td className="">20</td>
          <td className="">15</td>
          <td className="">10</td>
          <td className="">5</td>
        </tr>
        <tr>
          <th className="">6</th>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className="">500</td>
          <td className="">80</td>
          <td className="">60</td>
          <td className="">25</td>
          <td className="">20</td>
        </tr>
        <tr>
          <th className="">7</th>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className="">2000</td>
          <td className="">200</td>
          <td className="">150</td>
          <td className="">100</td>
        </tr>
        <tr>
          <th className="">8</th>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className="">2000</td>
          <td className="">2000</td>
          <td className="">500</td>
        </tr>
        <tr>
          <th className="">9</th>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className="">5000</td>
          <td className="">2000</td>
        </tr>
        <tr>
          <th className="">10</th>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className=""></td>
          <td className="">10000</td>
        </tr>
        </tbody>
      </table>
    </div>
  );
};
